import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddVendorUserContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'
import { checkEmailAvailable } from 'ducks/vendorMaintenance'
import r from 'reactotron-react-js'

const VendorUserModal = (props) => {
  const { valueForm, handleSubmit, onSubmitUser, showVendorUserModal, userData, 
    clearUserData, listUser, checkEmailAvailable, emailChecking } = props
  const isNew = userData ? false : true
  const { registerEzProcure } = valueForm

  const submitUser = () => {
    // if (valueForm.email === email && isAvailable === false && registerEzProcure) {
    //   throw new SubmissionError({ email: 'This email is already exist in EzProcure.' })
    // } else {
      var emailDuplicate = false
      if (isNew) {
        var u = listUser.find(u => u.email === valueForm.email)

        if (u) emailDuplicate = true
      } else {
        if (userData.email !== valueForm.email) {
          // Change email
          var user = listUser.find(u => u.email === valueForm.email)
          if (user) emailDuplicate = true
        }
      }

      if (!emailDuplicate) {
        if (valueForm.receiveChequeAtBank) {

          if (isNew) {
            var userRCB1 = listUser.filter(u => u.receiveChequeAtBank) || []
            if (userRCB1.length > 0) {
              throw new SubmissionError({ receiveChequeAtBank: 'Can select email for receive cheque at bank only one!' })
            }
          } else {
            var userRCB2 = listUser.find(u => u.receiveChequeAtBank && u.email !== userData.email)
            if (userRCB2) {
              throw new SubmissionError({ receiveChequeAtBank: 'Can select email for receive cheque at bank only one!' })
            }
          }
        }

        onSubmitUser(valueForm, isNew, userData)
        if (!isNew) clearUserData()
        showVendorUserModal(false)
      } else {
        throw new SubmissionError({ email: 'This email is not available!' })
      }
    // }
  }

  const onEmailFocusOut = (email) => {
    if (email) {
      if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        var emailDuplicate = false
        if (isNew) {
          var u = listUser.find(u => u.email === email)

          if (u) emailDuplicate = true
        } else {
          if (userData.email !== email) {
            var user = listUser.find(u => u.email === email)
            if (user) emailDuplicate = true
          }
        }

        if (!emailDuplicate) {
          checkEmailAvailable(email, onCheckEmailReturnedData)
        }
      }
    }
  }

  const onCheckEmailReturnedData = (email, isAvailable, message) => {
    if (!isAvailable) {
      throw new SubmissionError({ email: 'This email is not available!' })
    }
  }

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>EzProcure Registration and Communication</DialogTitle>
      <DialogContent>
        <form>
          <AddVendorUserContainer>
            <div className='rowFields'>
              <Field name='firstname' label='Firstname' require type={type.text} component={FieldInput} />
              <Field name='lastname' label='Lastname' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='email' 
                label='Email' 
                require 
                onBlur={(e, value) => {
                  onEmailFocusOut(value)
                }}
                type={type.text} 
                component={FieldInput} 
              />
              <Field name='mobile' label='Mobile' type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='telephone' label='Telephone' type={type.text} component={FieldInput} />
              <Field name='extension' label='Extension' type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='registerEzProcure' label='Register EzProcure' require type={type.checkbox} component={FieldInput} />
              <Field name='receiveChequeAtBank' label='Receive Payment Notification' require type={type.checkbox} component={FieldInput} />
            </div>
            {
                valueForm.email === emailChecking.email && emailChecking.isAvailable === false && 
                valueForm.registerEzProcure && emailChecking.message ?
                  <div className='rowFields'>
                    <div className='warningMessage'>
                      {emailChecking.message}
                    </div>
                  </div> : null
              }
          </AddVendorUserContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitUser())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            // disabled={disableAddButton()}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => {
              clearUserData()
              showVendorUserModal(false)
            }}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const userData = props.userData || {}
  const { accountGroup, paymentTypeCheque } = props
  return ({
    valueForm: getFormValues('formVendorUser')(state) || {},
    initialValues: {
      id: userData.id || null,
      firstname: userData.firstname || '',
      lastname: userData.lastname || '',
      email: userData.email || '',
      mobile: userData.mobile || '',
      telephone: userData.telephone || '',
      extension: userData.extension || '',
      allowAcceptPO: userData.allowAcceptPO || false,
      registerEzProcure: 
        (userData.registerEzProcure !== undefined && userData.registerEzProcure !== null) ? 
          userData.registerEzProcure : ['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(accountGroup),
      receiveChequeAtBank: 
        (userData.receiveChequeAtBank !== undefined && userData.receiveChequeAtBank !== null) ? 
          userData.receiveChequeAtBank : paymentTypeCheque,
    },
    emailChecking: state.vendorMaintenance.emailChecking
  })
}
  
const mapDispatchToProps = {
  checkEmailAvailable
}

const validate = (values) => {
  let errors = {}
  validations(values, 'firstname', [vCase.require], errors)
  validations(values, 'lastname', [vCase.require], errors)
  validations(values, 'mobile', [vCase.maxLength30], errors)
  validations(values, 'telephone', [vCase.maxLength30], errors)
  validations(values, 'extension', [vCase.maxLength10], errors)

  if (!values.email) {
    errors.email = 'Require!'
  } else {
    if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      errors.email = 'This email is wrong format!'
    }
  }

  return errors
}

const VendorUserForm = reduxForm({
  form: 'formVendorUser',
  enableReinitialize: true,
  validate
})(VendorUserModal)

export default connect(mapStateToProps, mapDispatchToProps)(VendorUserForm)